import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import CallToAction from "../../components/CallToAction";
import IntroBand from "../../components/IntroBand";
import counselorsData from "../../data/placeholder-counselor-data-utah.json";

const CounselorsSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
`;

const ProfileCard = styled.div`
  width: 450px;
  text-align: center;
  margin: 10px 20px;
`;

const ProfileImageWrap = styled.div`
  width: 450px;
  transition: scale 0.3s ease;
  overflow: hidden;
`;

const ProfileImage = styled.img`
  border-radius: 10px;
  transition: filter 0.3s ease, scale 0.3s ease;
  scale: 1;
  object-fit: cover;
  object-position: 0 ${(props) => (props.profilePosition ? `${props.profilePosition}` : '0')};
`;

const ScheduleLink = styled.a`
  color: #5e8a64;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.3;

  position: relative;
  padding-right: 10px;
  cursor: pointer;
  text-decoration: none;
`;

const CounselorExpertise = styled.div`
  font-size: 24px;
  line-height: 1.3;
  font-weight: bold;
  color: #5e8a64;
`;

const CounselorName = styled.div`
  font-size: 24px;
  line-height: 1.3;
  font-weight: bold;
`;

const CounselorTitle = styled.div`
  font-family: Raleway;
  font-size: 20px;
  line-height: 1.3;
  color: black;
`;

const Location = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.27;
`;

const Languages = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.27;
`;

const Tagline = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.27;
`;

const Hero = styled.div`
  z-index: 3;
  position: relative;

  nav {
    z-index: 3;
    position: relative;
  }
`;

const Title = styled.div`
  font-family: Raleway;
  font-size: 40px;
  font-weight: 400;
  line-height: 1.3;
  text-align: left;
  color: black;
  padding-top: 50px;
`;

const ArrowLink = styled.a`
  color: #5e8a64;
  font-size: 20px;
  font-weight: 400;
  line-height: 1.3;

  position: relative;
  padding-right: 40px;
  cursor: pointer;
  text-decoration: none;

  &::after {
    content: url("../images/arrow.svg");
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    transition: right ease 0.4s;
  }

  &:hover {
    opacity: 0.8;
    &::after {
      right: -10px;
    }
  }
  &:active {
    opacity: 0.5;
  }
`;

const ImproveWellbeing = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1184px;
  padding: 30 30px;
  text-align: left;

  img {
      width: 450px;
      height: 450px;
    }

  .text-block {
    width: 652px;
  }

  .text-block p {
    margin: 30px 30px 30px 0;
  }

  @media screen and (max-width: 970px) {
    flex-direction: column;
    flex-direction: column-reverse;

    .text-block p {
      margin: 30px auto;
    }
  }
`;

const Gap50 = styled.div`
  display: block;
  height: 50px;
`;

const IntroBandAuthor = styled.div`
  font-family: Raleway;
  font-size: 18px;
  font-weight: 400;
  line-height: 26px;
  text-align: center;
  margin-top: 15px;
`;

function TherapyPTSD() {

  const [counselor, setCounselor] = useState(counselorsData);

  useEffect(() => {
    const selectedItem = counselorsData.find((item) => item.name == "Lorraine Simmons")
    setCounselor(selectedItem || null);
  }, []);

  return (
    <div>
      <main>
        <div className="green-bg">
          <Hero>
            <Nav />
            <ImproveWellbeing id="improve-wellbeing" className="scroll-fade-in">
              <CounselorsSection>
                {counselor !== null ? (
                  <ProfileCard>
                    <CounselorExpertise>PTSD Therapy Expert</CounselorExpertise>
                    <CounselorName>{counselor.name}</CounselorName>
                    <CounselorTitle>{Array.isArray(counselor.qualifications) ? (counselor.qualifications[0]+', '+counselor.qualifications[1]) : (counselor.qualifications)}</CounselorTitle> 
                    <ProfileImageWrap>
                      <ProfileImage
                        src={`/images/counselors/profile-placeholders/${counselor.profile}`}
                        alt={counselor.name}
                        profilePosition={counselor.profilePosition}
                      />
                    </ProfileImageWrap>
                    <Languages>Languages: {Array.isArray(counselor.languages) ? (counselor.languages[0]+', '+counselor.languages[1]) : (counselor.languages)}</Languages>
                    <Location>Location: {counselor.location}</Location>
                    <Tagline>{counselor.tagline}</Tagline>
                    Schedule me:&nbsp;&nbsp;
                    <ScheduleLink target="_blank" href="sms:+15418180009">Text</ScheduleLink>
                    <ScheduleLink target="_blank" href="tel:+15418180009">Call</ScheduleLink>
                    <ScheduleLink target="_blank" href="/contact">Email</ScheduleLink>    
                </ProfileCard>
                ) : (<p>ERROR: No counselor item found.</p>)}
              </CounselorsSection>
              <div className="text-block">
                <Title>PTSD Therapy</Title>
                <p>Living with PTSD can feel like your mind is stuck in a constant state of alert—where everyday sights, sounds, or memories suddenly trigger intense fear, panic, or numbness. You might relive painful moments over and over or avoid situations that remind you of trauma, leaving you feeling disconnected from yourself and others.</p>
                <p>These symptoms can be exhausting and may lead to feelings of shame or isolation, but it’s important to remember that PTSD is a natural response to overwhelming experiences—<b>not a personal flaw</b>.</p>
                <p>Healing takes time, and therapy can provide a safe space to process trauma, develop coping skills, and rebuild your sense of safety and self-worth. Evidence-based therapies like <a href="/EMDR-modality">Eye Movement Desensitization and Reprocessing (EMDR)</a> are effective at reducing symptoms and improving overall functioning. Therapy offers a safe, supportive space to process these feelings, rebuild your sense of safety, and <b>reclaim your strength, one step at a time</b>.</p>                
                <p>If you're ready to take the next step <ArrowLink href="/contact">Contact Us</ArrowLink></p>
              </div>
            </ImproveWellbeing>
            </Hero>
            <IntroBand>
              <Gap50 />
              "Between stimulus and response there is a space. In that space is
              our power to choose our response. In our response lies our growth
              and our freedom."
              <IntroBandAuthor>- Viktor E. Frankl</IntroBandAuthor>
            </IntroBand>
          </div>
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
}

export default TherapyPTSD;
